export const EntityState = {
    DRAFT: 'DRAFT',
    SUBMITTED: 'SUBMITTED',
    EVALUATION: 'EVALUATION',
    FULLY_APPROVED: 'FULLY_APPROVED',
    CESSATION: 'CESSATION',

    values: () => {
        return ['DRAFT', 'SUBMITTED', 'EVALUATION', 'FULLY_APPROVED', 'CESSATION'];
    },

    requireDecision : () => {
        return ['SUBMITTED', 'EVALUATION'];
    },
};
